import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FramingBand } from '../components/FramingBand';
import { ProblemSection } from '../components/ProblemSection';
import { PlatformOverview } from '../components/PlatformOverview';
import { OperatingModel } from '../components/OperatingModel';
import { CapabilityDomains } from '../components/CapabilityDomains';
import { HumanOpportunity } from '../components/HumanOpportunity';
import { LifecycleArchitecture } from '../components/LifecycleArchitecture';
import { Solutions } from '../components/Solutions';
import { ProductEcosystem } from '../components/ProductEcosystem';
import { GlobalArchitecture } from '../components/GlobalArchitecture';
import { LeadershipReadiness } from '../components/LeadershipReadiness';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { RelatedInitiative } from '../components/initiatives/RelatedInitiative';
import { HumanCapabilityModels } from '../components/HumanCapabilityModels';
export function HumanCapabilityPage() {
  return <>
      <HeroSection data-id="element-2927" data-mp="3k524pl9s6tzs" />
      <FramingBand data-id="element-2928" data-mp="3k4ai2zy5w6ln" />
      <HumanCapabilityModels data-id="element-2929" data-mp="3k5vc8ogkdniz" />
      <ProblemSection data-id="element-2930" data-mp="3k2zfh3ggd4w4" />
      <PlatformOverview data-id="element-2931" data-mp="3p4f04uepx9dz" />
      <OperatingModel data-id="element-2932" data-mp="3p3ws70ip16q8" />
      <CapabilityDomains data-id="element-2933" data-mp="3p2lsbbsdcj4e" />
      <HumanOpportunity data-id="element-2934" data-mp="3p2bzzhjupzvj" />
      <LifecycleArchitecture data-id="element-2935" data-mp="3tuloct5birvp" />
      <Solutions data-id="element-2936" data-mp="3tvwxz9lg2tuq" />
      <ProductEcosystem data-id="element-2937" data-mp="3twgaubw8ms1w" />
      <RelatedInitiative name="Cognocracy" status="Concept Proposal" body="Explore a proposed civic application of the Human Capability Framework and NCJI." href="/projects/cognocracy" data-id="element-2938" data-mp="3twq202t0r596" />
      <GlobalArchitecture data-id="element-2939" data-mp="boqt4d4ixace" />
      <LeadershipReadiness data-id="element-2940" data-mp="bqk0jumynylg" />
      <FAQ data-id="element-2941" data-mp="bn5xsladxndh" />
      <FinalCTA data-id="element-2942" data-mp="bnfq4fiwk6mc" />
    </>;
}